import React from 'react';
import { BookOpen, Bookmark, FileText } from 'lucide-react';

const BookPreview = () => {
  return (
    <div className="py-24 px-4 bg-white/80" data-testid="book-preview-section">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-3">
          A Book That Tells Your Story
        </h2>
        <p className="text-center text-gray-500 mb-14 text-base">
          Professionally formatted, ready to cherish forever
        </p>

        <div className="grid md:grid-cols-3 gap-8 stagger-children">
          {/* Digital Book */}
          <div className="card-hover bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 text-center fade-in">
            <div className="w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center mx-auto mb-5">
              <FileText className="w-7 h-7 text-purple-500" />
            </div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Digital PDF</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Beautifully formatted PDF with title page, chapters, and page numbers. Download instantly.
            </p>
            <p className="mt-4 text-2xl font-bold text-gray-800">£25</p>
            <p className="text-xs text-gray-500">Included with purchase</p>
          </div>

          {/* Hardcover */}
          <div className="card-hover bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 text-center border-2 border-amber-200 fade-in relative">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-amber-400 to-orange-400 text-white text-xs font-bold px-3 py-1 rounded-full">
              POPULAR
            </div>
            <div className="w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center mx-auto mb-5">
              <BookOpen className="w-7 h-7 text-amber-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Hardcover Book</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Professional 6"x9" hardcover with glossy cover. Printed and shipped to your door.
            </p>
            <p className="mt-4 text-2xl font-bold text-gray-800">From £59</p>
            <p className="text-xs text-gray-500">Printed by Lulu</p>
          </div>

          {/* Gift */}
          <div className="card-hover bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-8 text-center fade-in">
            <div className="w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center mx-auto mb-5">
              <Bookmark className="w-7 h-7 text-pink-500" />
            </div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Gift Bundle</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Two hardcover copies — one for you and one for a loved one. The perfect gift.
            </p>
            <p className="mt-4 text-2xl font-bold text-gray-800">£89</p>
            <p className="text-xs text-gray-500">Save £29</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookPreview;
